import type {
  IntegrationConfig,
  IntegrationConfigCreateInput,
  IntegrationConfigListQueryParams,
} from 'src/core/data/api/IntegrationConfig';
import BaseService from './base-service';

export default class IntegrationConfigService extends BaseService {
  constructor() {
    super('integrationconfig');
  }

  list(query?: IntegrationConfigListQueryParams): Promise<IntegrationConfig[]> {
    return super.list(query);
  }

  save(data: IntegrationConfigCreateInput): Promise<IntegrationConfig> {
    return super.save(data);
  }

  update(data: IntegrationConfig): Promise<IntegrationConfig> {
    return super.update(data);
  }

  remove(id: number): Promise<IntegrationConfig> {
    return super.remove(id);
  }
}
